/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ vekn: NonNullable<unknown> }} User_List_Vekn_CopiedInputs */



/**
* | output |
* | --- |
* | "VEKN ID {vekn} copied to clipboard" |
*
* @param {User_List_Vekn_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_list_vekn_copied = /** @type {((inputs: User_List_Vekn_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_List_Vekn_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`ID VEKN ${i?.vekn} copié dans le presse-papiers`)
	if (locale === "es") return /** @type {LocalizedString} */ (`ID VEKN ${i?.vekn} copiado al portapapeles`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`ID VEKN ${i?.vekn} copiado para a área de transferência`)
	if (locale === "it") return /** @type {LocalizedString} */ (`ID VEKN ${i?.vekn} copiato negli appunti`)
	return /** @type {LocalizedString} */ (`VEKN ID ${i?.vekn} copied to clipboard`)
});